import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { VendorMiArea } from 'src/app/models/department-reports.model';
import { BaseService } from 'src/app/services/common/base.service';
import { ReportsService } from 'src/app/services/reports.service';
import saveAs from 'file-saver';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { Location } from '@angular/common';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';

@Component({
  selector: 'app-mi-consolidated-total-app-report',
  templateUrl: './mi-consolidated-total-app-report.component.html',
  styleUrls: ['./mi-consolidated-total-app-report.component.scss'],
})
export class MiConsolidatedTotalAppReportComponent implements OnInit {
  consolidateData: any = [];
  public districtsArray: any = [];
  public distWiseTotalApp: any = [];
  public loading: boolean = false;

  appVerificationModel: VendorMiArea[];
  tempConsolidateData: any[];
  arrayIndex: number;

  totalApp: any;
  totalArea: any;
  verifiedApp: any;
  verifiedAppArea: any;
  pendingApp: any;
  incompleteApp: any;
  incompleteAppArea: any;
  rejectApp: any;
  totalEstimatedApp: any;
  totalEstimatedArea: any;
  verifiedEstimateApp: any;
  verifiedEstimateArea: any;
  pendingEstimateApp: any;
  verifiedEstApproved: any;
  verifiedEstApprovedArea: any;
  pendingEstApproved: any;
  rejectedEstVerified: any;
  challanGenerated: any;
  challanDeposited: any;
  BOQUploaded: any;
  BOQMIArea: any;
  BOQPending: any;
  PVCompleted: any;
  PV_MI_Area: any;
  PV_Pending_with_JE: any;
  PV_Pending_with_XEN: any;
  PV_Pending_with_SDO: any;
  pending_Subsidy_Calculation: any;
  applicationswithDMIforSubsidy_Approval: any;
  applications_Approved_at_Administartion: any;
  subsisdy_Approved_MI_Area: any;
  assistanceAmount: any;
  pending_Application_For_Payment_By_CAO: any;
  payment_Done_Application_By_CAO: any;
  payment_done_MI_Area: any;

  grandTotalApp: any;
  grandTotalArea: any;
  grandVerifiedApp: any;
  grandVerifiedAppArea: any;
  grandPendingApp: any;
  grandIncompleteApp: any;
  grandIncompleteAppArea: any;
  grandRejectApp: any;
  grandTotalEstimatedApp: any;
  grandTotalEstimatedArea: any;
  grandVerifiedEstimateApp: any;
  grandVerifiedEstimateArea: any;
  grandPendingEstimateApp: any;
  grandVerifiedEstApproved: any;
  grandVerifiedEstApprovedArea: any;
  grandPendingEstApproved: any;
  grandRejectedEstVerified: any;
  grandChallanGenerated: any;
  grandChallanDeposited: any;
  grandBOQUploaded: any;
  grandBOQMIArea: any;
  grandBOQPending: any;
  grandPVCompleted: any;
  grandPV_MI_Area: any;
  grandPV_Pending_with_JE: any;
  grandPV_Pending_with_XEN: any;
  grandPV_Pending_with_SDO: any;
  grandPending_Subsidy_Calculation: any;
  grandApplicationswithDMIforSubsidy_Approval: any;
  grandApplications_Approved_at_Administartion: any;
  grandSubsisdy_Approved_MI_Area: any;
  grandAssistanceAmount: any;
  grandPending_Application_For_Payment_By_CAO: any;
  grandPayment_Done_Application_By_CAO: any;
  grandPayment_done_MI_Area: any;

  public subjectSub: any;
  public subscriptions: any = [];
  public selectedYear: any;

  public drilldownDetails: any;
  public displayPendingDetailUser: boolean = false;

  appVerificationItems: MenuItem[];

  filteredVillage: any;
  // districtList: any = [];

  finYearList: any = [];
  selectedFinYear: any = null;
  constituencyList: any = [];
  selectedconstituency: any = null;
  districtList: any = [];
  selectedDistrict: any = null;
  blockList: any = [];
  selectedBlock: any = null;
  villageList: any = [];
  selectedVillage: any = null;

  cropTypeList: any = [];
  selectedCrop: any = null;
  casteList: any = [];
  selectedCaste: any = null;
  appTypeList: any = [];
  selectedAppType: any = null;

  scrollHeight: any = '130px';

  column1Name: any = "District";

  public cropMergeList: any;
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  constructor(
    private reportsService: ReportsService,
    private messageService: MessageService,
    private service: BaseService,
    private _personalDetalSer: FarmersDetailsService,
    private location: Location,
    private reportService: ReportsService,
    private flService: FarmerLandDetailService
  ) {}

  ngOnInit(): void {
    // this.loadDataAndApplyFilter();
    // this.loadData('');
    this.getFinYearList();
    this.getDistrictList();
    this.getConstituencyList();
    this.getCasteList();
    this.getCorpTypeList();
    this.getAppTypeList();

    this.onClickApplyFilter();

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'MI_Consolidate_report');
        },
      },
      // {
      //   label: 'Download Pdf',
      //   icon: 'pi pi-fw pi-download',
      //   command: () => {
      //     this.downloadSheetAsPdf(
      //       this.appVerificationModel,
      //       'MI_Consolidate_report'
      //     );
      //   },
      // },
    ];
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.appVerificationModel, "Vendor_wise_report");
      //   }
      // },
    ];
  }

  getDistrictList() {
    let sub = this.reportService
      .getDistrictMaster()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.districtList = data;
          } else {
            this.districtList = [];
          }
        },
        error: (err) => {
          this.districtList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'District List Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getCorpTypeList() {
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.cropTypeList = data;

            let arrayCrop = [];
            let cropMerge = data.map((parent) => {
              arrayCrop.push(
                parent['children'].map((child) => ({
                  ...child,
                  parentData: parent.data,
                  parentLabel: parent.label
                }))
              );
            });

            this.cropMergeList = [].concat(...arrayCrop);

          } else {
            this.cropTypeList = [];
            this.cropMergeList = [];
          }
        },
        error: (err) => {
          this.cropTypeList = [];
          this.cropMergeList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Crop Type List',
            detail: err,
          });
        },
      });
  }

  getCasteList(){
    setTimeout(() => {
      this.casteList = [
        {
          Caste_Code: 1,
          Caste_Description: 'Gen'
        },
        {
          Caste_Code: 2,
          Caste_Description: 'BC'
        },
        {
          Caste_Code: 3,
          Caste_Description: 'SC'
        }
      ]
    }, 200)
  }

  getAppTypeList(){
    setTimeout(() => {
      this.appTypeList = [
        {
          AppType_Code: 1,
          AppType_Description: 'Normal'
        },
        {
          AppType_Code: 2,
          AppType_Description: 'ABY'
        }
      ]
    }, 200)
  }

  getFinYearList() {
    let sub = this.reportService
      .getFinanacialYearList()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.finYearList = data;
          } else {
            this.finYearList = [];
          }
        },
        error: (err) => {
          this.finYearList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Finanacial Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getConstituencyList() {
    let sub = this.reportService
      .getConsituencyMaster()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.constituencyList = data;
          } else {
            this.constituencyList = [];
          }
        },
        error: (err) => {
          this.constituencyList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Constituency List Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectConstituency(){
    this.selectedVillage = null;
    this.villageList = [];

    let constituencyCode = this.selectedconstituency?.Constituency_Code ? this.selectedconstituency?.Constituency_Code : '';
    let blockCode = this.selectedBlock?.Block_Code ? this.selectedBlock?.Block_Code : '';
    this.getVillageList(blockCode, constituencyCode);
  }

  onSelectDistrict(){
    this.selectedBlock = null;
    this.blockList = [];


    let districtCode = this.selectedDistrict?.Dist_Code;
    this.getBlockList(districtCode);
  }

  getBlockList(districtCode) {
    let sub = this.reportService
      .getBlockMaster(districtCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.blockList = data;
          } else {
            this.blockList = [];
          }
        },
        error: (err) => {
          this.blockList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Block List Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onSelectBlock(){
    this.selectedVillage = null;
    this.villageList = [];

    let constituencyCode = this.selectedconstituency?.Constituency_Code ? this.selectedconstituency?.Constituency_Code : '';
    let blockCode = this.selectedBlock?.Block_Code ? this.selectedBlock?.Block_Code : '';
    this.getVillageList(blockCode, constituencyCode);
  }

  getVillageList(blockCode, conCode) {
    let sub = this.reportService
      .getVillageMasterByConsituency(blockCode, conCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.villageList = data;
          } else {
            this.villageList = [];
          }
        },
        error: (err) => {
          this.villageList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Village List Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  // getVillageData(){
  //   this._personalDetalSer.getVillageMatserData().subscribe(res => {
  //     this.villageList = res;
  //     this.filteredVillage = [...this.villageList]

  //     if (!window.localStorage.getItem("villageMaster")) {
  //       window.localStorage.setItem("villageMaster", JSON.stringify(res));
  //     }
  //   })
  // }

  // filterVillage(event: any) {
  //   const filtered: any[] = [];
  //   const query = event.query;
  //   for (let i = 0; i < this.villageList.length; i++) {
  //     const village = this.villageList[i];
  //     if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
  //       filtered.push(village);
  //     }
  //   }

  //   this.filteredVillage = filtered;
  // }

  // loadDataAndApplyFilter(){
  //   if(sessionStorage.getItem('financialYear')){
  //     this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
  //   }

  //   this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
  //     (res) => {

  //       this.selectedYear = res;
  //       this.loadData(this.selectedYear);
  //     }
  //   );
  // }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  loadData(reqBody) {
    this.loading = true;

    let sub = this.reportService
      .getConsolidated_Report(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            if(data?.length == 1) {
              this.scrollHeight = '180px';
            }else if(data?.length <=5) {
              this.scrollHeight = '300px';
            }else{
              this.scrollHeight = '400px';
            }

            this.consolidateData = data;
            // console.log(this.consolidateData);
            this.districtsArray = this.consolidateData.map(
              (item) => item['District']
            );
            this.distWiseTotalApp = this.consolidateData.map(
              (item) => item['totalApp']
            );
            // console.log(this.districtsArray);
            // this.loadPieChartData();

            this.appVerificationModel = data;
            this.tempConsolidateData = data;
            this.arrayIndex = 0;
            this.calculateGrandTotal();
            // this.applyNewGraph1Data();
            this.loading = false;
          } else {
            this.scrollHeight = '130px';
            this.consolidateData = [];
            this.appVerificationModel = [];
            this.tempConsolidateData = [];
            this.calculateGrandTotal();
            // this.loader.close();
            this.loading = false;
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.scrollHeight = '130px';
          // this.loader.close();
          this.consolidateData = [];
          this.appVerificationModel = [];
          this.tempConsolidateData = [];
          this.calculateGrandTotal();
          this.loading = false;
          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'MI Consolidated Report',
          //   '',
          //   new Date(),
          //   err
          // );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  calculateGrandTotal() {
    this.grandTotalApp = 0;
    this.grandTotalArea = 0;
    this.grandVerifiedApp = 0;
    this.grandVerifiedAppArea = 0;
    this.grandPendingApp = 0;
    this.grandIncompleteApp = 0;
    this.grandIncompleteAppArea = 0;
    this.grandRejectApp = 0;
    this.grandTotalEstimatedApp = 0;
    this.grandTotalEstimatedArea = 0;
    this.grandVerifiedEstimateApp = 0;
    this.grandVerifiedEstimateArea = 0;
    this.grandPendingEstimateApp = 0;
    this.grandVerifiedEstApproved = 0;
    this.grandVerifiedEstApprovedArea = 0;
    this.grandPendingEstApproved = 0;
    this.grandRejectedEstVerified = 0;
    this.grandChallanGenerated = 0;
    this.grandChallanDeposited = 0;
    this.grandBOQUploaded = 0;
    this.grandBOQMIArea = 0;
    this.grandBOQPending = 0;
    this.grandPVCompleted = 0;
    this.grandPV_MI_Area = 0;
    this.grandPV_Pending_with_JE = 0;
    this.grandPV_Pending_with_XEN = 0;
    this.grandPV_Pending_with_SDO = 0;
    this.grandPending_Subsidy_Calculation = 0;
    this.grandApplicationswithDMIforSubsidy_Approval = 0;
    this.grandApplications_Approved_at_Administartion = 0;
    this.grandSubsisdy_Approved_MI_Area = 0;
    this.grandAssistanceAmount = 0;
    this.grandPending_Application_For_Payment_By_CAO = 0;
    this.grandPayment_Done_Application_By_CAO = 0;
    this.grandPayment_done_MI_Area = 0;

    for (let vendorData of this.tempConsolidateData) {
      this.grandTotalApp += vendorData.totalApp;
      this.grandTotalArea += vendorData.TotalArea;
      this.grandVerifiedApp += vendorData.VerifiedApp;
      this.grandVerifiedAppArea += vendorData.verifiedAppArea;
      this.grandPendingApp += vendorData.PendingApp;
      this.grandIncompleteApp += vendorData.IncompleteApp;
      this.grandIncompleteAppArea += vendorData.incompleteAppArea;
      this.grandRejectApp += vendorData.rejectApp;
      this.grandTotalEstimatedApp += vendorData.totalEstimatedApp;
      this.grandTotalEstimatedArea += vendorData.totalEstimatedArea;
      this.grandVerifiedEstimateApp += vendorData.verifiedEstimateApp;
      this.grandVerifiedEstimateArea += vendorData.verifiedEstimateArea;
      this.grandPendingEstimateApp += vendorData.pendingEstimateApp;
      this.grandVerifiedEstApproved += vendorData.verifiedEstApproved;
      this.grandVerifiedEstApprovedArea += vendorData.verifiedEstApprovedArea;
      this.grandPendingEstApproved += vendorData.pendingEstApproved;
      this.grandRejectedEstVerified += vendorData.rejectedEstVerified;
      this.grandChallanGenerated += vendorData.ChallanGenerated;
      this.grandChallanDeposited += vendorData.ChallanDeposited;
      this.grandBOQUploaded += vendorData.BOQUploaded;
      this.grandBOQMIArea += vendorData.BOQMIArea;
      this.grandBOQPending += vendorData.BOQPending;
      this.grandPVCompleted += vendorData.PVCompleted;
      this.grandPV_MI_Area += vendorData.PV_MI_Area;
      this.grandPV_Pending_with_JE += vendorData.PV_Pending_with_JE;
      this.grandPV_Pending_with_XEN += vendorData.PV_Pending_with_XEN;
      this.grandPV_Pending_with_SDO += vendorData.PV_Pending_with_SDO;
      this.grandPending_Subsidy_Calculation +=
        vendorData.Pending_Subsidy_Calculation;
      this.grandApplicationswithDMIforSubsidy_Approval +=
        vendorData.ApplicationswithDMIforSubsidy_Approval;
      this.grandApplications_Approved_at_Administartion +=
        vendorData.Applications_Approved_at_Administartion;
      this.grandSubsisdy_Approved_MI_Area +=
        vendorData.Subsisdy_Approved_MI_Area;
      this.grandAssistanceAmount += vendorData.AssistanceAmount;
      this.grandPending_Application_For_Payment_By_CAO +=
        vendorData.Pending_Application_For_Payment_By_CAO;
      this.grandPayment_Done_Application_By_CAO +=
        vendorData.Payment_Done_Application_By_CAO;
      this.grandPayment_done_MI_Area += vendorData.Payment_done_MI_Area;
    }
  }

  showPendingDetailUserDialog(value, actionType, ...args) {
    // this.value = value;

    // console.log(value)

    // let finYear = this.selectedFinYear?.FinancialYears ? this.selectedFinYear.FinancialYears : '';
    // let constituency = this.selectedconstituency?.Constituency_Code ? this.selectedconstituency?.Constituency_Code : '';
    // let district = this.selectedDistrict?.Dist_Code ? this.selectedDistrict?.Dist_Code : '';
    // let block = this.selectedBlock?.Block_Code ? this.selectedBlock?.Block_Code : '';
    // let village = this.selectedVillage?.Vill_Code ? this.selectedVillage?.Vill_Code : '';
    // let crop = this.selectedCrop?.data ? this.selectedCrop?.data : 0;
    // let caste = this.selectedCaste?.Caste_Description ? this.selectedCaste?.Caste_Description : '';
    // let appType = this.selectedAppType?.AppType_Description ? this.selectedAppType?.AppType_Description : '';

    this.drilldownDetails = {
      ActionType: actionType,
      District: '',
      FinYear: this.selectedFinYear?.FinancialYears ? this.selectedFinYear.FinancialYears : '',
      RequestType: 'MI',
      ReqParam: args[0] ? args[0] : '',
      GeoType: this.selectedconstituency?.Vill_Code ? 'Village' : ((this.selectedBlock?.Block_Code ? 'Village' : (this.selectedDistrict?.Dist_Code ? 'Block' : 'District'))),
      GeoCode: value?.District_Code,
      Caste: this.selectedCaste?.Caste_Description ? this.selectedCaste?.Caste_Description : '',
      CropId: this.selectedCrop?.data ? this.selectedCrop?.data : 0,
      userType: this.selectedAppType?.AppType_Description ? this.selectedAppType?.AppType_Description : '',
    };

    this.displayPendingDetailUser = true;
    // console.log(this.drilldownDetails, 'this.drilldownDetails');
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          // 'Financial Year': this.selectedYear == '' ? 'All' : this.selectedYear,
          District: d.District,
          // Block: d.Block,
          // Constituency: d.Constituency,
          '': '',
          'Total App(application approval)': d.totalApp,
          'Total Area(application approval)': d.TotalArea,
          'Verified App(application approval)': d.VerifiedApp,
          'Verified App Area(application approval)': d.verifiedAppArea,
          'Pending App(application approval)': d.PendingApp,
          'Incomplete App Area(application approval)': d.incompleteAppArea,
          'Reject App(application approval)': d.rejectApp,
          '  ': '',
          'Total Estimated App(estimate)': d.totalEstimatedApp,
          'Total Estimated Area(estimate)': d.totalEstimatedArea,
          'Pending Estimate App(estimate)': d.pendingEstimateApp,
          '   ': ' ',
          'Verified Estimate App (estimate Approval)': d.verifiedEstimateApp,
          'Verified Estimate Area (estimate Approval)': d.verifiedEstimateArea,

          'Verified Est Approved (estimate Approval)': d.verifiedEstApproved,
          'Verified Est Approved Area (estimate Approval)':
            d.verifiedEstApprovedArea,
          'Pending Est Approved (estimate Approval)': d.pendingEstApproved,
          'Rejected Est Verified (estimate Approval)': d.rejectedEstVerified,
          '    ': ' ',
          'Challan Generated(challan)': d.ChallanGenerated,
          'Challan Deposited(challan)': d.ChallanDeposited,
          '     ': ' ',
          'BOQ Uploaded(BOQ)': d.BOQUploaded,
          'BOQ MI Area(BOQ)': d.BOQMIArea,
          'BOQ Pending(BOQ)': d.BOQPending,
          '      ': ' ',
          'PV Completed(PV)': d.PVCompleted,
          'PV MI Area(PV)': d.PV_MI_Area,
          'PV Pending with JE(PV)': d.PV_Pending_with_JE,
          'PV Pending with XEN(PV)': d.PV_Pending_with_XEN,
          'PV Pending with SDO(PV)': d.PV_Pending_with_SDO,
          '       ': ' ',
          'Pending Subsidy Calculation(SUBSIDY CAL)':
            d.Pending_Subsidy_Calculation,
          'Applications with DMI for Subsidy_Approval(SUBSIDY CAL)':
            d.ApplicationswithDMIforSubsidy_Approval,
          'Applications Approved at Administartion(SUBSIDY CAL)':
            d.Applications_Approved_at_Administartion,
          'Subsisdy Approved MI Area(SUBSIDY CAL)': d.Subsisdy_Approved_MI_Area,
          'Assistance Amount(SUBSIDY CAL)': d.AssistanceAmount,
          '        ': ' ',
          'Pending Application For Payment By CAO(SUBSIDY )':
            d.Pending_Application_For_Payment_By_CAO,
          'Payment Done Application By CAO(SUBSIDY )':
            d.Payment_Done_Application_By_CAO,
          'Payment done MI Area(SUBSIDY )': d.Payment_done_MI_Area,
        };
      });

      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onPage(event: any) {
    this.arrayIndex = event.first;
    this.calculateTotalApp();
  }
  calculateTotalApp() {
    this.totalApp = 0;
    this.totalArea = 0;
    this.incompleteAppArea = 0;
    this.verifiedApp = 0;
    this.verifiedAppArea = 0;
    this.pendingApp = 0;
    this.incompleteApp = 0;
    this.incompleteAppArea = 0;
    this.rejectApp = 0;
    this.totalEstimatedApp = 0;
    this.totalEstimatedArea = 0;
    this.verifiedEstimateApp = 0;
    this.verifiedEstimateArea = 0;
    this.pendingEstimateApp = 0;
    this.verifiedEstApproved = 0;
    this.verifiedEstApprovedArea = 0;
    this.pendingEstApproved = 0;
    this.rejectedEstVerified = 0;
    this.challanGenerated = 0;
    this.challanDeposited = 0;
    this.BOQUploaded = 0;
    this.BOQMIArea = 0;
    this.BOQPending = 0;
    this.PVCompleted = 0;
    this.PV_MI_Area = 0;
    this.PV_Pending_with_JE = 0;
    this.PV_Pending_with_XEN = 0;
    this.PV_Pending_with_SDO = 0;
    this.pending_Subsidy_Calculation = 0;
    this.applicationswithDMIforSubsidy_Approval = 0;
    this.applications_Approved_at_Administartion = 0;
    this.subsisdy_Approved_MI_Area = 0;
    this.assistanceAmount = 0;
    this.pending_Application_For_Payment_By_CAO = 0;
    this.payment_Done_Application_By_CAO = 0;
    this.payment_done_MI_Area = 0;
    for (
      let i = this.arrayIndex;
      this.tempConsolidateData.length > 10
        ? i < this.arrayIndex + 10
        : i < this.tempConsolidateData.length;
      i++
    ) {
      this.totalApp += this.tempConsolidateData[i].totalApp;
      this.totalArea += this.tempConsolidateData[i].TotalArea;
      this.verifiedApp += this.tempConsolidateData[i].VerifiedApp;
      this.verifiedAppArea += this.tempConsolidateData[i].verifiedAppArea;
      this.pendingApp += this.tempConsolidateData[i].PendingApp;
      this.incompleteApp += this.tempConsolidateData[i].IncompleteApp;
      this.incompleteAppArea += this.tempConsolidateData[i].incompleteAppArea;
      this.rejectApp += this.tempConsolidateData[i].rejectApp;
      this.totalEstimatedApp += this.tempConsolidateData[i].totalEstimatedApp;
      this.totalEstimatedArea += this.tempConsolidateData[i].totalEstimatedArea;
      this.verifiedEstimateApp +=
        this.tempConsolidateData[i].verifiedEstimateApp;
      this.verifiedEstimateArea +=
        this.tempConsolidateData[i].verifiedEstimateArea;
      this.pendingEstimateApp += this.tempConsolidateData[i].pendingEstimateApp;
      this.verifiedEstApproved +=
        this.tempConsolidateData[i].verifiedEstApproved;
      this.verifiedEstApprovedArea +=
        this.tempConsolidateData[i].verifiedEstApprovedArea;
      this.pendingEstApproved += this.tempConsolidateData[i].pendingEstApproved;
      this.rejectedEstVerified +=
        this.tempConsolidateData[i].rejectedEstVerified;
      this.challanGenerated += this.tempConsolidateData[i].ChallanGenerated;
      this.challanDeposited += this.tempConsolidateData[i].ChallanDeposited;
      this.BOQUploaded += this.tempConsolidateData[i].BOQUploaded;
      this.BOQMIArea += this.tempConsolidateData[i].BOQMIArea;
      this.BOQPending += this.tempConsolidateData[i].BOQPending;
      this.PVCompleted += this.tempConsolidateData[i].PVCompleted;
      this.PV_MI_Area += this.tempConsolidateData[i].PV_MI_Area;
      this.PV_Pending_with_JE += this.tempConsolidateData[i].PV_Pending_with_JE;
      this.PV_Pending_with_XEN +=
        this.tempConsolidateData[i].PV_Pending_with_XEN;
      this.PV_Pending_with_SDO +=
        this.tempConsolidateData[i].PV_Pending_with_SDO;
      this.pending_Subsidy_Calculation +=
        this.tempConsolidateData[i].Pending_Subsidy_Calculation;
      this.applicationswithDMIforSubsidy_Approval +=
        this.tempConsolidateData[i].ApplicationswithDMIforSubsidy_Approval;
      this.applications_Approved_at_Administartion +=
        this.tempConsolidateData[i].Applications_Approved_at_Administartion;
      this.subsisdy_Approved_MI_Area +=
        this.tempConsolidateData[i].Subsisdy_Approved_MI_Area;
      this.assistanceAmount += this.tempConsolidateData[i].AssistanceAmount;
      this.pending_Application_For_Payment_By_CAO +=
        this.tempConsolidateData[i].Pending_Application_For_Payment_By_CAO;
      this.payment_Done_Application_By_CAO +=
        this.tempConsolidateData[i].Payment_Done_Application_By_CAO;
      this.payment_done_MI_Area +=
        this.tempConsolidateData[i].Payment_done_MI_Area;
    }
    // this.verfAppArea= this.verfAppArea.toFixed(4);
  }

  tableDataFunction(event: any) {
    this.tempConsolidateData = event.filteredValue;
    this.arrayIndex = 0;
    this.calculateTotalApp();
  }

  onClickBack() {
    this.location.back();
  }

  onClickApplyFilter() {
    let finYear = this.selectedFinYear?.FinancialYears ? this.selectedFinYear.FinancialYears : '';
    let constituency = this.selectedconstituency?.Constituency_Code ? this.selectedconstituency?.Constituency_Code : '';
    let district = this.selectedDistrict?.Dist_Code ? this.selectedDistrict?.Dist_Code : '';
    let block = this.selectedBlock?.Block_Code ? this.selectedBlock?.Block_Code : '';
    let village = this.selectedVillage?.Vill_Code ? this.selectedVillage?.Vill_Code : '';
    let crop = this.selectedCrop?.data ? this.selectedCrop?.data : 0;
    let caste = this.selectedCaste?.Caste_Description ? this.selectedCaste?.Caste_Description : '';
    let appType = this.selectedAppType?.AppType_Description ? this.selectedAppType?.AppType_Description : '';

    let reqBody = {
      "financialYear": finYear,
      "constituency": constituency,
      "district": district,
      "block": block,
      "village": village,
      "cropid": crop,
      "caste": caste,
      "isABY": appType
    }

    if(constituency && district == ''){
      this.column1Name = "Village";
    }else if(constituency == '' && district && block == ''){
      this.column1Name = "Block";
    }else if((constituency && district) || (district && block) || (constituency && district && block)){
      this.column1Name = "Village";
    }else{
      this.column1Name = "District";
    }

    this.loadData(reqBody);
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'VendorName', header: 'Vendor Name'},
      { field: 'TotalApplication', header: 'Total Application' },
      { field: 'VerifiedApplication', header: 'Verified Application' },
      { field: 'ReturnProcessApplication', header: 'Return Process Application' },
      { field: 'PendingEarly', header: 'On Time' },
      { field: 'Pending_1Week', header: 'Pending by one Week' },
      { field: 'Pending_Morethan_1Weeks', header: 'Pending More than one Weeks' },
      { field: 'RejectedApplication', header: 'Rejected Application' },
      { field: 'MIArea', header: 'Mi Area' },
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
}
